"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useForm() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = (0, _react.useState)(settings["default"] || {}),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      setErrors = _useState4[1];

  var handleChange = function handleChange(ev) {
    var name = ev.target.name;
    var val = ev.target.value;
    var error = errors[name];

    if (error) {
      var req = settings.reqs[name];

      var clear = function clear() {
        setErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, undefined)));
      };

      if ((error === req.required || error === "".concat(name, " is required")) && val.length > 0) {
        clear();
      } else if (req.min && error === "".concat(name, " is too short") || req.min && _typeof(req.min) === "object" && error === req.min.message) {
        if (typeof req.min === "number" && req.min <= val.length) clear();else if (_typeof(req.min) === "object" && req.min.value <= val.length) clear();
      } else if (req.max && error === "".concat(name, " is too long") || req.max && _typeof(req.max) === "object" && error === req.max.message) {
        if (typeof req.max === "number" && req.max > val.length) clear();else if (_typeof(req.max) === "object" && req.max.value > val.length) clear();
      } else if (req.email && error === req.email && validateEmail(val)) {
        clear();
      }
    }

    setData(_objectSpread(_objectSpread({}, data), {}, _defineProperty({}, name, val)));
  };

  var checkErrors = function checkErrors() {
    var foundErrors = {};
    var reqs = settings.reqs;
    if (!reqs) return false;
    var reqsKeys = Object.keys(reqs);
    if (!reqsKeys || !reqsKeys.length) return false;
    reqsKeys.forEach(function (key) {
      var req = reqs[key];
      var dat = data[key];

      try {
        if (req) {
          if (req.required && !dat && !dat[key] && !dat.length) {
            foundErrors[key] = typeof req.required === "string" ? req.required : "".concat(key, " is required");
          } else if (req.min && typeof req.min === "number" && req.min > dat.length) {
            foundErrors[key] = "".concat(key, " is too short");
          } else if (req.min && _typeof(req.min) === "object" && req.min.value > dat.length) {
            foundErrors[key] = req.min.message || "".concat(key, " is too short");
          } else if (req.max && typeof req.max === "number" && req.max <= dat.length) {
            foundErrors[key] = "".concat(key, " is too long");
          } else if (req.max && _typeof(req.max) === "object" && req.max.value <= dat.length) {
            foundErrors[key] = req.max.message || "".concat(key, " is too long");
          } else if (req.email && !validateEmail(dat)) {
            if (typeof req.email === "string") foundErrors[key] = req.email;else foundErrors[key] = "".concat(key, " is not a valid email");
          }
        }
      } catch (_unused) {
        foundErrors[key] = typeof req === "string" ? req : "".concat(key, " is required");
      }
    });
    setErrors(foundErrors);
    return Object.keys(foundErrors).length > 0;
  };

  return {
    handleChange: handleChange,
    checkErrors: checkErrors,
    errors: errors,
    data: data
  };
}

var validateEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

var _default = useForm;
exports["default"] = _default;